import React, { useState, useEffect, useRef } from 'react';
import GradientButton from '../../../components/atoms/GradientButton';
import { motion, useInView } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';
import CrossFadeImageSlider from '../../../components/molecules/CrossFadeImageSlider';

const TextAndImageComp = ({
  title,
  subTitle,
  des,
  btnText,
  imageUrl,
  bgColor,
  direction,
  align,
  btnLink,
  alt,
}) => {
  const imageRef = useRef(null);
  const isMultipleImages = Array.isArray(imageUrl);
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  const isInView = useInView(imageRef, { once: true, amount: 1 });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (isInView && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [isInView, hasAnimated]);

  return (
    <div className={`${bgColor}`}>
      <div
        className={`w-full flex flex-col ${
          direction === 'row' ? 'md:flex-row' : 'md:flex-row-reverse'
        } justify-between ${
          align === 'start' ? 'items-start' : 'items-end'
        } gap-6 md:gap-10 2xl:gap-20 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-24 relative z-10`}
      >
        <div className="flex-1 flex flex-col gap-2 sm:gap-4">
          {title && (
            <h2 className="text-[38px] sm:text-[50px] 2xl:text-[68px] text-[#7E4B9D] font-bold leading-[40px] sm:leading-[50px] 2xl:leading-[64px] mb-2 sm:mb-3 max-w-[460px]">
              {title}
            </h2>
          )}
          <h4 className="text-[28px] sm:text-[34px] text-[#7E4B9D] font-bold leading-tight">
            {subTitle}
          </h4>
          <p
            className="text-secondary text-lg 2xl:text-2xl mb-6"
            dangerouslySetInnerHTML={{ __html: des }}
          />
          <GradientButton
            text={btnText}
            navigateTo={btnLink}
            width={'w-full sm:w-[350px]'}
          />
        </div>
        <div className="flex-1" ref={imageRef}>
          {isMultipleImages ? (
            <CrossFadeImageSlider
              width="w-[94vw] md:w-full"
              height="h-[300px] md:h-[380px]"
              images={imageUrl}
              alt={alt}
            />
          ) : (
            <motion.img
              src={imageUrl}
              key={imageUrl}
              alt={alt}
              initial={
                isMobile
                  ? { opacity: 0 }
                  : { x: direction === 'row' ? 300 : -300, opacity: 0 }
              }
              animate={
                isInView
                  ? { x: 0, opacity: 1 }
                  : { x: direction === 'row' ? 300 : -300, opacity: 0 }
              }
              exit={{ opacity: 0 }}
              on
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 1, ease: 'easeInOut' }}
              className="rounded-3xl max-h-full md:max-h-[340px] w-full object-cover"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TextAndImageComp;
